import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { CustomerListHolderFullNameCell } from './customer-list-holder-full-name.cell';
import { CustomerListHolderFullNameHeader } from './customer-list-holder-full-name.header';

export const CustomerListHolderFullNameColumn: IdentifiedColumnDef<
  GatewayCustomerModel,
  GatewayCustomerModel['holder']
> = {
  enableSorting: false,
  header: CustomerListHolderFullNameHeader,
  cell: CustomerListHolderFullNameCell,
};
